import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		dialogContent: {
			[theme.breakpoints.up("sm")]: {
				width: 470,
			},
			padding: 16,
		},
		dialogActions: {
			paddingRight: "24px",
			paddingBottom: "16px",
		},
	} satisfies Record<string, CSSObject>;
};
